import { useState } from 'react'

const useModal = () => {
  const [showBidModal, setShowBidModal] = useState<any>(false)
  const [showBanModal, setShowBanModal] = useState<any>(false)
  const [negativeZBid, setNegativeZBid] = useState<any>(true)
  const [negativeZBan, setNegativeZBan] = useState<any>(true)
  const [modalAction, setModalAction] = useState<any>(null)
  const [modalData, setModalData] = useState<any>({})

  const hideModal = (type: any) => {
    let timeoutFunc: any = null
    if (type === 'Bid') {
      setShowBidModal(false)
      timeoutFunc = () => setNegativeZBid(true)
    }
    if (type === 'Ban') {
      setShowBanModal(false)
      timeoutFunc = () => setNegativeZBan(true)
    }
    setTimeout(timeoutFunc, 200)
  }
  const toggleModal = (show: any, type: any) => {
    if (show) {
      if (type === 'Bid') {
        setShowBidModal(true)
        setNegativeZBid(false)
      }
      if (type === 'Ban') {
        setShowBanModal(true)
        setNegativeZBan(false)
      }
    } else {
      hideModal(type)
    }
  }

  return [
    {
      showBidModal,
      showBanModal,
      negativeZBid,
      negativeZBan,
      modalAction,
      modalData,
    },
    { toggleModal, setModalAction, setModalData },
  ]
}

export default useModal
